import { WELLNESS, DENTAL, ARTGALLERY, FITNESS } from './Domains';

export const MINDBODY = 'MINDBODY';
export const BOOKER = 'BOOKER';
export const DENTRIX = 'DENTRIX';
export const EAGLESOFT = 'EAGLESOFT';
export const GOOGLECALENDAR = 'GOOGLECALENDAR';
export const ACUITY = 'ACUITY';
export const ZENOTI = 'ZENOTI';
export const PHOREST = 'PHOREST';
export const MYTIME = 'MYTIME';
export const BOULEVARD = 'BOULEVARD';
export const RESTORE = 'RESTORE';
export const MEEVO = 'MEEVO';
export const NEXHEALTH = 'NEXHEALTH';
export const CLOUD9 = 'CLOUD9';
export const DENTICON = 'DENTICON';
export const DENTRIX_ASCEND = 'DENTRIX_ASCEND';
export const SCIBLER = 'SCIBLER';
export const OPEN_DENTAL = 'OPEN_DENTAL';
export const OTHER = 'OTHER';

export default {
  [MINDBODY]: {
    label: 'MindBody',
    value: MINDBODY,
    type: [WELLNESS, FITNESS],
  },
  [BOOKER]: {
    label: 'Booker',
    value: BOOKER,
    type: [WELLNESS, FITNESS],
  },
  [DENTRIX]: {
    label: 'Dentrix',
    value: 'DENTRIX',
    type: [DENTAL],
  },
  [EAGLESOFT]: {
    label: 'Eagle Soft',
    value: 'EAGLESOFT',
    type: [DENTAL],
  },
  [NEXHEALTH]: {
    label: 'NEXHEALTH',
    value: 'NEXHEALTH',
    type: [DENTAL],
  },
  [CLOUD9]: {
    label: 'CLOUD9',
    value: 'CLOUD9',
    type: [DENTAL],
  },
  [OPEN_DENTAL]: {
    label: 'OPEN_DENTAL',
    value: 'OPEN_DENTAL',
    type: [DENTAL],
  },
  [DENTICON]: {
    label: 'DENTICON',
    value: 'DENTICON',
    type: [DENTAL],
  },
  [DENTRIX_ASCEND]: {
    label: 'DENTRIX_ASCEND',
    value: 'DENTRIX_ASCEND',
    type: [DENTAL],
  },
  [GOOGLECALENDAR]: {
    label: 'Google Calendar',
    value: 'GOOGLECALENDAR',
    type: [ARTGALLERY],
  },
  [ZENOTI]: {
    label: 'Zenoti',
    value: ZENOTI,
    type: [WELLNESS, FITNESS],
  },
  [ACUITY]: {
    label: 'Acuity',
    value: ACUITY,
    type: [WELLNESS, FITNESS],
  },
  [PHOREST]: {
    label: 'Phorest',
    value: PHOREST,
    type: [WELLNESS, FITNESS],
  },
  [MYTIME]: {
    label: 'MyTime',
    value: MYTIME,
    type: [WELLNESS, FITNESS],
  },
  [BOULEVARD]: {
    label: 'BOULEVARD',
    value: BOULEVARD,
    type: [WELLNESS, FITNESS],
  },
  [RESTORE]: {
    label: 'RESTORE',
    value: RESTORE,
    type: [WELLNESS, FITNESS],
  },
  [MEEVO]: {
    label: 'MEEVO',
    value: MEEVO,
    type: [WELLNESS, FITNESS],
  },
  [SCIBLER]: {
    label: 'NON API INTEGRATED',
    value: SCIBLER,
    type: [WELLNESS, FITNESS, DENTAL],
  },
};
